'use strict';

var React = require('react');

var SvgButtonCornerRoundedMajor = function SvgButtonCornerRoundedMajor(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M8.837 2.79a6.047 6.047 0 0 0-6.046 6.047v11.163h-2.791v-11.163a8.837 8.837 0 0 1 8.837-8.837h11.163v2.79h-11.163z"
  }));
};

exports.SvgButtonCornerRoundedMajor = SvgButtonCornerRoundedMajor;
